import Flickity from './Frontend';

// Make Flickity global (used for events)
window.Flickity = Flickity;

let flickityLoadedEvent = new Event('__ggFlickityLoaded');

document.dispatchEvent(flickityLoadedEvent);
